// Deterministic team colours derived from team name.
// Used everywhere a team appears (cards, feed, badges) so the same team
// is always represented by the same colour across the app.

const PALETTE = [
  { bg: "#dcfce7", border: "#86efac", dot: "#16a34a", text: "#15803d" }, // green
  { bg: "#dbeafe", border: "#93c5fd", dot: "#2563eb", text: "#1d4ed8" }, // blue
  { bg: "#fef3c7", border: "#fcd34d", dot: "#d97706", text: "#b45309" }, // amber
  { bg: "#fce7f3", border: "#f9a8d4", dot: "#db2777", text: "#be185d" }, // pink
  { bg: "#ede9fe", border: "#c4b5fd", dot: "#7c3aed", text: "#6d28d9" }, // violet
  { bg: "#cffafe", border: "#67e8f9", dot: "#0891b2", text: "#0e7490" }, // cyan
  { bg: "#fee2e2", border: "#fca5a5", dot: "#dc2626", text: "#b91c1c" }, // red
  { bg: "#f3e8ff", border: "#d8b4fe", dot: "#9333ea", text: "#7e22ce" }, // purple
];

function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function teamColor(name: string, index?: number) {
  if (typeof index === "number" && index >= 0) {
    return PALETTE[index % PALETTE.length];
  }
  if (!name) return PALETTE[0];
  return PALETTE[hash(name.trim().toLowerCase()) % PALETTE.length];
}

// For consistency across screens that only have a team name, look up the
// team's position in the club's teams array.
export function teamColorByName(name: string, allTeams?: string[]) {
  if (allTeams) {
    const i = allTeams.indexOf(name);
    if (i >= 0) return teamColor(name, i);
  }
  return teamColor(name);
}
